export const LIST = "LIST";
export const STORE = "STORE";
export const EDIT = "EDIT";
export const UPDATE = "UPDATE";
export const UPDATE_STATUS = "UPDATE_STATUS";
export const ADD_VOUCHER_MEMBER = "ADD_VOUCHER_MEMBER";
export const GET_VOUCHER_MEMBER = "GET_VOUCHER_MEMBER";
export const SHOW_VOUCHER = "SHOW_VOUCHER";
export const DELETE_VOUCHER_MEMBER = "DELETE_VOUCHER_MEMBER";
export const ADD_SPECIFIC_VOUCHER_MEMBER = "ADD_SPECIFIC_VOUCHER_MEMBER";
export const DELETE_ONE_VOUCHER_MEMBER = "DELETE_ONE_VOUCHER_MEMBER";